import { LoginForm } from "./components/login/LoginForm";
import "./styles/Auth.module.css";

export const Login = () => {
  return (
    <div className="">
      <div className="">
        <LoginForm />
      </div>
    </div>
  );
};
